import React, { useEffect, useState, useRef } from 'react'
import cn from 'classnames'
import Button from '@/components/Button'
import MainJeka from './MainJeka'
import { useConfig, useModal, usePlatform } from '@/hooks'
import { IUnityInstance } from '@/interfaces/Unity'
import { groupBy } from '@/utils/groupBy'
import { getCookie, isMobile, setCookie } from '@/utils'
import { preloaderBackground, jekahandside } from '@/images'
import { UnityProgress } from '../helpers'
import { IRangeLoading } from '../interfaces'
import RangeLoader from './RangeLoader'
import { SHOW_STATUSES, TUTOR_COOKIE_INFO, LABELS_LOADER } from '../const'

import { api } from '@/api'
import style from '../styles/game.module.scss'
import { Mobile } from './Mobile'

const FIRS_LABEL = LABELS_LOADER[0]

const MainGames: React.FC = () => {
  const config = useConfig()
  const userPlatform = usePlatform()
  const { openModal } = useModal()

  const [platformGroup, setPlatformGroup] = useState<Map<any, any> | null>(
    null
  )
  const [showStatus, setShowStatus] = useState(SHOW_STATUSES.hide)
  const [rangeLoding, setRangeLoding] = useState<IRangeLoading>({
    value: 0
  })
  const [labelLoader, setlabelLoader] = useState(FIRS_LABEL)
  const [isOpenScreenLoader, setisOpenScreenLoader] = useState(true)
  const [isMobileMod, setMobileMod] = useState(false)
  const prevLabel = useRef(FIRS_LABEL)
  const timerCloseLoader = useRef<any>()
  const timerSwapTextLoader = useRef<any>(null)
  const [tutorStep, setTutorStep] = useState(-1)

  const platformObj = platformGroup?.get(userPlatform)?.[0]
  const downloadLink = platformObj?.uf_file_build ?? ''
  const {
    games = '/',
    education = '/',
    tournaments = '/',
    news = '/',
    leaders_contacts: leadersContacts = ''
  } = config

  const updatePercentLoadGame = (percent: number): void => {
    setRangeLoding({
      value: percent
    })
  }

  const redirectToPage = ({ url }: { url: string }): void => {
    location.href = url
  }

  const endLoadingScene = (): void => {
    updatePercentLoadGame(100)

    timerCloseLoader.current = setTimeout(() => {
      setisOpenScreenLoader(false)
    }, 200)
  }

  const checkTutorCompleted = (): boolean => {
    const isCompleted = getCookie(TUTOR_COOKIE_INFO.key)
    if (isCompleted === TUTOR_COOKIE_INFO.completedTrue) {
      return true
    }
    return false
  }

  const showTutor = (): void => {
    const tutorIsCompleted = checkTutorCompleted()
    if (!tutorIsCompleted) {
      setTutorStep(0)
      setShowStatus(SHOW_STATUSES.show)
    }
  }

  const hideTutor = (): void => {
    setShowStatus(SHOW_STATUSES.close)
    setCookie(
      TUTOR_COOKIE_INFO.key,
      TUTOR_COOKIE_INFO.completedTrue,
      TUTOR_COOKIE_INFO.days
    )
  }

  const initUnity = (): void => {
    updatePercentLoadGame(20)
    const unityPlayer = 'UnityPlayer'
    const nodeUnityPlayer = document.getElementById(unityPlayer)
    if (nodeUnityPlayer == null) {
      const script = document.createElement('script')
      script.id = unityPlayer
      script.type = 'text/javascript'
      script.src = '/HomeGame/Build/UnityLoader.js'
      script.addEventListener('load', function (event) {
        updatePercentLoadGame(70)
        window?.UnityLoader?.instantiate(
          'unityContainer',
          '/HomeGame/Build/SiteWebgl.json',
          {
            onProgress: (
              unityInstance: IUnityInstance,
              progress: number
            ): void => {
              if (progress === 1) {
                setTimeout(() => showTutor(), 3500)
              } else {
                updatePercentLoadGame(80)
              }
              UnityProgress(unityInstance, progress)
            }
          }
        )
      })
      document.body.appendChild(script)
    } else {
      window?.UnityLoader?.instantiate(
        'unityContainer',
        '/HomeGame/Build/SiteWebgl.json',
        { onProgress: UnityProgress }
      )
    }
  }

  const initMobileMod = (): void => {
    endLoadingScene()
    setMobileMod(true)
    setTimeout(() => showTutor(), 300)
  }

  const getGame = (): void => {
    api
      .getLastGame()
      .then((data) => {
        const systems = data?.system_requirements ?? []
        setPlatformGroup(groupBy(systems, (obj) => obj.uf_os_key))
      })
      .catch((err) => console.log(err))
  }

  const showFamilyModal = (): void => {
    openModal('family')
  }

  const setUnityCustomEvents = (): void => {
    window.PROXY_EVENT_HUB = {
      CONTACTS: () => redirectToPage({ url: leadersContacts }),
      EDUCATION: () => redirectToPage({ url: education }),
      FAMILY: () => showFamilyModal(),
      GAMES: () => redirectToPage({ url: games }),
      NEWS: () => redirectToPage({ url: news }),
      TOURNEY: () => redirectToPage({ url: tournaments }),
      INIT_SCENE: () => endLoadingScene()
    }
  }

  useEffect(() => {
    if (rangeLoding.value === 100) {
      clearTimeout(timerSwapTextLoader.current)
      timerSwapTextLoader.current = undefined
    }
  }, [rangeLoding])

  useEffect(() => {
    if (timerSwapTextLoader.current === null) {
      timerSwapTextLoader.current = setInterval(() => {
        let idx = Math.ceil(Math.random() * 8)
        while (LABELS_LOADER[idx] === prevLabel.current) {
          idx = Math.ceil(Math.random() * 8)
        }
        setlabelLoader(LABELS_LOADER[idx])
      }, 3000)
    }
  }, [timerSwapTextLoader.current])

  useEffect(() => {
    if (!isMobile.any()) {
      initUnity()
    } else {
      initMobileMod()
    }
    getGame()
    setUnityCustomEvents()

    return () => {
      timerCloseLoader.current = null
    }
  }, [])

  const chageTutorStep = (): void => {
    if (tutorStep < 7) {
      let nextStep = tutorStep + 1
      // isMobileMod
      if (isMobileMod && nextStep === 2) {
        nextStep = 3
      }
      setTutorStep(nextStep)
    }
  }

  return (
    <>
      <div
        className={cn({
          [style.preloader]: true,
          [style['preloader--hide']]: !isOpenScreenLoader
        })}
      >
        <img
          className={style['preloader--image']}
          src={preloaderBackground}
          alt='preload image'
          width='100%'
          height='100%'
        />
        <div className={style['preloader--container']}>
          <div className={style['preloader--content']}>
            <div className={style.preloader__circle}>
              <div className={style['preloader__circle--border']}>
                <img
                  className={style['preloader__circle--icon']}
                  src={jekahandside}
                  width='100%'
                  height='100%'
                  alt='icon'
                />
              </div>
            </div>
            <RangeLoader value={rangeLoding.value} label={labelLoader} />
          </div>
        </div>
      </div>
      {isMobileMod ? <Mobile /> : <div id='unityContainer' />}
      {showStatus !== SHOW_STATUSES.hide
        ? (
          <MainJeka
            showStatus={showStatus}
            step={tutorStep}
            chageTutorStep={chageTutorStep}
            hideTutor={hideTutor}
          />
          )
        : null}
      {downloadLink !== ''
        ? (
          <Button
            href={downloadLink}
            download
            className={style.upload__game}
            corner
          >
            Скачать игру
          </Button>
          )
        : null}
    </>
  )
}

export default MainGames
